import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-qavisitreportnotaccepted",
  templateUrl: "./qavisitreportnotaccepted.component.html",
  styleUrls: ["./qavisitreportnotaccepted.component.scss"],
})
export class QavisitreportnotacceptedComponent implements OnInit {
  title: string = "تقارير الجودة الغير مقبولة";
  isReviewed: boolean = true;
  hideActions: boolean = false;
  status = 2;
  constructor() {}

  ngOnInit() {}
}
